import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";
import {
  formatCPF,
  timeStampToDateWithTimeUtc,
  timeStampToDate,
  formatUpperCase,
  formatCpfCnpj,
} from "../../../../utils/formats";

const ConsultaSCRSection = (props) => {
  const {
    proposalConsultaSCRLoading,
    numeroCpfCnpj,
    nomeCliente,
    dataBase,
    qtdeOperacoes,
    qtdeIFs,
    qtdeOperacoesSubJudice,
    qtdeOperacoesDiscordancia,
    inicioRelacionamento,
    ultimaConsulta,
  } = props;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="CPF/CNPJ"
            value={formatCpfCnpj(numeroCpfCnpj)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Cliente"
            value={formatUpperCase(nomeCliente)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Data base"
            value={dataBase}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Quantidade de operações"
            value={qtdeOperacoes}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Quantidade de IFs"
            value={qtdeIFs}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Quantidade Op. Sub-Judice"
            value={qtdeOperacoesSubJudice}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Quantidade Op. Discordância"
            value={qtdeOperacoesDiscordancia}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Data início relacionamento"
            value={timeStampToDate(inicioRelacionamento)}
          />
        </Grid>
        <Grid item xs={4}>
          <Input
            loading={proposalConsultaSCRLoading}
            label="Data da última consulta"
            value={timeStampToDateWithTimeUtc(ultimaConsulta)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ConsultaSCRSection;
